<template>
    <div class="orderManagementClass">
        <div class="orderManagementContent" :style="contentViewHeight">
            <div class="printOrderListBox">
                <div>
                    <div class="orderSearchBox">
                        <el-input v-model="name" placeholder="姓名"></el-input>
                        <el-input v-model="contactWay" placeholder="联系方式"></el-input>
                        <el-select v-model="status" placeholder="状态">
                            <el-option label="已处理" value="PROCESSED"> </el-option>
                            <el-option label="待处理" value="PENDING"> </el-option>
                        </el-select>
                        <el-button class="searchBtn" @click="search">搜索</el-button>
                        <el-button type="text" class="resetBtn" @click="resetData">
                            <i class="iconfont icon-qingchushujuku"></i>
                            <span>清除条件</span>
                        </el-button>
                    </div>
                    <div class="orderListTable">
                        <div class="tableTool">
                            <div class="toolRight">
                                <el-button type="primary" size="small" :disabled="multipleSelection.length<1" @click="handleDeal('')"><i
                                    class="el-icon-circle-plus-outline"></i>处理
                                </el-button>
                                <el-button type="primary" size="small" :disabled="multipleSelection.length<1" @click="handleDelete"><i
                                    class="el-icon-circle-plus-outline"></i>删除
                                </el-button>
                            </div>
                        </div>
                        <el-table
                            :data="tableData"
                            border
                            style="width: 100%" class="tableContent"  @selection-change="handleSelectionChange">
                            <el-table-column
                                type="selection"
                                header-align="center"
                                align="center"
                                width="55">
                            </el-table-column>
                            <el-table-column
                                prop="name"
                                label="姓名"
                                header-align="center"
                                show-overflow-tooltip
                                width="150"
                                align="center">
                            </el-table-column>

                            <el-table-column
                                prop="contactWay"
                                label="联系方式"
                                header-align="center"
                                show-overflow-tooltip
                                width="150"
                                align="center">
                            </el-table-column>
                            <el-table-column
                                prop="content"
                                align="center"
                                header-align="center"
                                label="内容" >
                            </el-table-column>

                            <el-table-column
                                prop="statusCn"
                                align="center"
                                header-align="center"
                                width="150"
                                label="状态">
                            </el-table-column>
                            <el-table-column
                                label="操作"
                                header-align="center"
                                width="150"
                                align="center">
                                <template slot-scope="scope">
                                    <el-button type="text" size="small" @click="showMessage(scope.row)">查看</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-pagination
                            background
                            @current-change="handleCurrentChange"
                            @prev-click="handleCurrentChange"
                            @next-click="handleCurrentChange"
                            layout="total,prev, pager, next,jumper"
                            :current-page="current"
                            :page-size="pageSize"
                            :total="total" class="pagination">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>

        <el-dialog
            title="留言信息"
            :visible.sync="messageShow"
            width="1000px" :close-on-click-modal="false">
            <div class="examine">
                <div class="examineList examineListTwo">
                    <div class="examineListTwo_box">
                        <p style="white-space:nowrap">姓名:</p>
                        <p>{{ messageInfo.name }}</p>
                    </div>
                    <div class="examineListTwo_box">
                        <p style="white-space:nowrap">联系方式:</p>
                        <p>{{ messageInfo.contactWay }}</p>
                    </div>
                </div>
                <div class="examineList">
                    <p>内容 :</p>
                    <p v-html="messageInfo.content" class="examine_html vHtmlMess"></p>
                </div>
            </div>
            <div class="examine_btn">
                <el-button type="primary" v-show="messageInfo.status=='PENDING'" @click="handleDeal(messageInfo.uuid)">处理</el-button>
                <el-button @click="messageShow = false">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { messageQuery,messageDealBatch,messageDelete,getMessageInfo} from '../../utils/interface';

    export default {
        components: {
        },
        data() {
            return {
                status:'',
                name:'',
                contactWay: '',
                tableData: [],
                current: 1,
                pageSize: 10,
                total: 0,
                multipleSelection:[],
                messageShow:false,
                messageInfo:{}
            }
        },
        computed: {
            contentViewHeight() {
                let height = document.documentElement.clientHeight - 120
                return {minHeight: height + 'px'}
            },
        },
        created() {
            this.getList();
        },
        methods: {
            getList(){
                let params = {
                    name:this.name,
                    contactWay:this.contactWay,
                    current:this.current,
                    pageSize:this.pageSize,
                    multipleSelection: [],
                    status:this.status,
                }
                messageQuery(params).then((res)=>{
                    this.tableData = res.data;
                    this.total = res.total;
                });
            },
            resetData(){
                this.status='';
                this.name = '';
                this.contactWay = '';
                this.current = 1;
                this.getList();
            },
            // 分页
            handleCurrentChange(val){
                this.current = val;
                this.getList();
            },
            search(){
                this.current = 1;
                this.getList();
            },

            init(){
                this.name = '';
                this.contactWay = '';
                this.current = 1;
                this.getList()
            },
            // 复选框选中值
            handleSelectionChange(val) {
                this.multipleSelection = val
            },
            handleDeal(uuid){
                let uuidArr=[];
                if(uuid){
                    uuidArr.push(uuid);
                }else {
                    this.multipleSelection.map((item) => {
                        uuidArr.push(item.uuid);
                    });
                }
                this.$confirm('确定要处理吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    messageDealBatch(uuidArr).then((res)=>{
                        if(res.success){
                            this.$message({
                                type: 'success',
                                message: '处理成功!'
                            });
                            this.messageShow = false;
                            this.getList();
                        } else {
                            this.$message({
                                type: 'waring',
                                message: res.message
                            });
                        }
                    });
                }).catch(() => {})
            },
            handleDelete(){
                let uuidArr=[];
                this.multipleSelection.map((item) => {
                    uuidArr.push(item.uuid);
                });
                this.$confirm('确定要删除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    messageDelete(uuidArr).then((res)=>{
                        if(res.success){
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.getList();
                        } else {
                            this.$message({
                                type: 'waring',
                                message: res.message
                            });
                        }
                    });
                }).catch(() => {})
            },
            showMessage(item){
                this.messageShow = true;
                this.messageInfo = item;
            }
        }
    }
</script>

<style scoped lang="less">
    .orderManagementClass {
        position: relative;
        width: 100%;
        padding: 0 20px 20px;
        .orderManagementContent {
            background: #fff;
            .printOrderListBox {
                padding: 20px;
                .orderSearchBox {
                    display: flex;
                    flex-wrap: wrap;

                    /deep/ .el-input {
                        width: initial;
                        margin-bottom: 22px;
                        margin-right: 30px;
                    }

                    /deep/ .el-input__inner {
                        width: 242px;
                        height: 35px;
                        min-height: 35px;
                        font-size: 12px;
                        color: #999999;
                        background-color: #f2f4f7;
                        border: 1px solid #f2f4f7;
                        border-radius: 5px;

                        &:hover,
                        &:focus {
                            background-color: #fff;
                            border: 1px solid #108ee9;
                        }
                    }

                    /deep/ .el-input__prefix {
                        top: -3px;
                    }

                    /deep/ .el-input__suffix {
                        top: 2px;
                    }

                    /deep/ .el-button {
                        display: block;
                        line-height: 35px;
                        padding: 0;
                        height: 35px;
                    }

                    .searchBtn {
                        width: 82px;
                        background: #3d7fff;
                        border: none;
                        border-radius: 15px;
                        font-size: 14px;
                        color: #ffffff;
                    }

                    .resetBtn {
                        color: #333333;
                    }
                }

                .tableContent {
                    min-height: 650px;

                    /deep/ .el-table__header {
                        tr {
                            th {
                                border-right: none;
                            }
                        }

                        /deep/ .el-table__cell {
                            padding: 5px 0;
                            background: #f2f5fc;
                        }
                    }

                    /deep/ .el-table__body {
                        img {
                            vertical-align: middle;
                            width: 52px;
                            height: 50px;
                        }
                    }
                }

                .pagination {
                    margin-top: 20px;
                    text-align: right;
                }
            }
        }
        .tableTool {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            margin-bottom: 20px;
            .toolRight {
                button {
                    width: 83px;
                    height: 30px;
                    background: rgba(21, 126, 251, 1);
                    border: none;
                    border-radius: 15px;
                    font-size: 13px;
                    color: #fff;

                    i {
                        padding-right: 5px;
                    }

                    &:hover {
                        background: #61a2f0;
                    }
                }
            }
        }
        .dialogBox{
            .details{
                .detailsItem{
                    padding-bottom: 20px;
                    h3{
                        font-weight: 700;
                        font-size: 16px;
                        color: #000;
                        margin-top: 0;
                        letter-spacing: 1px;
                        border-bottom: 1px solid #ddd;
                        padding-bottom: 15px;
                    }
                    .itemContent{
                        display: flex;
                        flex-wrap: wrap;
                        font-size: 15px;
                        padding: 0 30px;
                        .one-row{
                            width: 50%;
                            margin-bottom: 22px;
                            display: flex;
                            .label{
                                padding-right: 15px;
                                min-width: 95px;
                            }
                            .name{
                                color: #000;
                            }
                        }
                        .two-row{
                            width: 100%;
                            margin-bottom: 22px;
                            display: flex;
                            .label{
                                padding-right: 15px;
                                min-width: 95px;
                            }
                            .name{
                                color: #000;
                            }
                        }
                    }
                    .itemPictureContent{
                        display: flex;
                        flex-wrap: wrap;
                        font-size: 15px;
                        padding: 0 30px;
                        justify-content: space-between;
                        .one-row{
                            width: 30%;
                            margin-bottom: 22px;
                            img{
                                width: 100%;
                                height: 138px;
                                border: 1px solid #ddd;
                            }
                            .name{
                                text-align: center;
                                padding-top: 10px;
                                font-size: 14px;
                                display: flex;
                                .label{
                                    min-width: 80px;
                                }
                            }
                        }
                    }
                }
            }
            .audit{
                padding-bottom: 20px;
                h3{
                    font-weight: 700;
                    font-size: 16px;
                    color: #000;
                    margin-top: 0;
                    letter-spacing: 1px;
                    border-bottom: 1px solid #ddd;
                    padding-bottom: 15px;
                }
                .auditContent{
                    padding: 0 30px;
                }
                .cause{
                    display: flex;
                    margin-top: 20px;
                    .causeTitle{
                        min-width: 80px;
                        color: #3a8ee6;
                    }
                    .causeContent{
                        color: #000;
                    }
                }
                .auditEnter{
                    text-align: center;
                    padding-top: 20px;
                    button{
                        width: 120px;
                    }
                }
            }
        }
    }
    .examine_btn {
        text-align: right;
        button {
            margin-left: 10px;

        }
    }
    .examine {
        h2 {
            font-weight: 700;
            font-size: 16px;
            color: #000;
            margin-top: 26px;
            letter-spacing: 1px;
        }
        .examineList {
            display: flex;
            // align-items: center;
            img {
                width: 300px;
                height: 150px;
            }
            p:nth-of-type(1){
                margin-right: 16px;
                width: 65px;
                flex-shrink: 0;
            }
            .examine_html {
                width: 90%;
                /deep/pre {
                    white-space: pre-line !important;
                }
                /deep/img {
                    max-width: 100%;
                }
            }
        }
        .examineListTwo {
            display: flex;
            align-items: center;
            .examineListTwo_box {
                display: flex;
                align-items: center;
                width: 50%;
            }
        }

    }
</style>



// WEBPACK FOOTER //
// src/views/applet/appletMessageList.vue